<app-template>
    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="container-privacy" *ngIf="info">
            <div class="header-privacy">
                <h1><p>
                    DESCARGA <br> {{info.pais}}
                </p></h1>
            </div>
            <div class="privacy-content">
                <div>
                    <p>{{info.resumen}}</p>
                </div>
                <br>
                <div style="width: 100%; margin: 10px auto" id="form">

                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <div class="content-res">
                <h1>DESCARGA <br> {{info.pais}}</h1>
                <p class="text">
                    {{info.resumen}}
                </p>
                <div style="width: 100%; margin: 10px auto" id="form-movil">

                </div>
            </div>
        </div>
    </div>
</app-template>
